import { render, staticRenderFns } from "./MarkupsTableRow.vue?vue&type=template&id=0c9cf49b&"
import script from "./MarkupsTableRow.vue?vue&type=script&lang=ts&"
export * from "./MarkupsTableRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports